import React from "react";
import Aggregate from "./aggregate";
import UrlManagement from "./../../shared/url_management.js";

class AggregateFilters extends React.Component {
  constructor(props) {
    super(props);
    this.url = new UrlManagement();
    this.manageFilter = this.manageFilter.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.clearAllAppliedFilters = this.clearAllAppliedFilters.bind(this);
    this.closeFilters = this.closeFilters.bind(this);
    this.state = {
      appliedFilters: [],
      original_url: location.search
    };
  }

  manageFilter(filter) {
    if (!_.isEmpty(filter)) {
      var exists = false;
      _.each(this.state.appliedFilters, f => {
        if (_.isEqual(f, filter)) {
          exists = true;
          return false;
        }
      });
      if (exists) {
        let newFilters = this.state.appliedFilters.slice();
        let newf = _.filter(newFilters, f => {
          return !_.isEqual(f, filter);
        });
        this.setState({ appliedFilters: newf }, this.updateSearch);
      } else {
        let newFilters = this.state.appliedFilters.slice();
        newFilters.push(filter);
        this.setState({ appliedFilters: newFilters }, this.updateSearch);
      }
    } else {
      this.setState({ appliedFilters: [] });
    }
  }

  updateSearch() {
    this.props.handleSearch(this.state.appliedFilters);
  }

  clearAllAppliedFilters() {
    this.url.clearUrl();
    this.setState({
      appliedFilters: []
    }, () => {
      this.url.setUrl(this.state.original_url);
      this.updateSearch();
    });
  }

  closeFilters() {
    const filters = document.querySelector(".filters");
    filters.classList.toggle("filters--visible");
    document.body.classList.toggle("no-scroll");
  }

  render() {
    var reset =
      this.url.hasFiltersApplied() === true ? (
        <span
          className="filters-title__reset"
          onClick={this.clearAllAppliedFilters}
        >
          Reset
        </span>
      ) : (
        ""
      );
    return (
      <div className="filters">
        <div className="filters-title">
          <h3 className="filters-title__name">Filters</h3>
          <div className="filters-title__btns">
            {reset}
            <i
              className="material-icons filters-title__close-btn"
              onClick={this.closeFilters}
            >
              &#xE5CD;
            </i>
          </div>
        </div>
        {this.props.aggs.map((a, i) => {
          return (
            <div className="filter" key={i}>
              <Aggregate
                title={a.title}
                data={a.values}
                agg={a.agg_type}
                aggType={a.title}
                appliedFilters={this.state.appliedFilters}
                handleSearch={this.manageFilter}
                view={this.state.view}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export { AggregateFilters as default };
